import { render, staticRenderFns } from "./SearchUserAsync.vue?vue&type=template&id=bc82fcec&"
import script from "./SearchUserAsync.vue?vue&type=script&lang=js&"
export * from "./SearchUserAsync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports